const HIDDEN_GROUPS_KEY = 'hiddenGroups';
const READ_ONLY_GROUPS_KEY = 'readOnlyGroups';

export function loadHiddenGroups() {
  try {
    const saved = localStorage.getItem(HIDDEN_GROUPS_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

export function saveHiddenGroups(map) {
  try {
    localStorage.setItem(HIDDEN_GROUPS_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function hideGroupFromList(groupId, meta = {}) {
  const current = loadHiddenGroups();
  const next = {
    ...current,
    [groupId]: {
      _id: groupId,
      name: meta.name || 'Group',
      avatar: meta.avatar ?? null,
      hiddenAt: Date.now(),
    },
  };
  saveHiddenGroups(next);
  return next;
}

export function unhideGroup(groupId) {
  const current = loadHiddenGroups();
  if (!current[groupId]) return current;
  const next = { ...current };
  delete next[groupId];
  saveHiddenGroups(next);
  return next;
}

export function loadReadOnlyGroups() {
  try {
    const saved = localStorage.getItem(READ_ONLY_GROUPS_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

export function saveReadOnlyGroups(map) {
  try {
    localStorage.setItem(READ_ONLY_GROUPS_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function removeFromReadOnlyGroups(groupId) {
  const current = loadReadOnlyGroups();
  if (!current[groupId]) return current;
  const next = { ...current };
  delete next[groupId];
  saveReadOnlyGroups(next);
  return next;
}

export function addToReadOnlyGroups(groupId, meta = {}) {
  const current = loadReadOnlyGroups();
  const next = {
    ...current,
    [groupId]: {
      _id: groupId,
      name: meta.name || 'Group',
      avatar: meta.avatar ?? null,
    },
  };
  saveReadOnlyGroups(next);
  return next;
}
